import { __decorate } from "tslib";
import { FrontendFeaturePlugin, provideRootRoutes } from '@core/frontend-shared';
import { ClassName } from '@core/shared/class-name';
import * as i0 from "@angular/core";
let FaqFrontendAdminFeature = /*#__PURE__*/(() => {
  let FaqFrontendAdminFeature = class FaqFrontendAdminFeature extends FrontendFeaturePlugin {
    getFeatureContext() {
      return {"package":"@common/faq/frontend-admin","featureId":"common-faq"};
    }
    getFeatureFunctionality(functionality) {
      functionality.defineMenuItems({
        adminToolbar: [{
          label: 'FAQ',
          priority: 3,
          routerLink: 'faq',
          icon: 'question-circle',
          items: [{
            label: 'Fragen',
            routerLink: 'faq/questions'
          }, {
            label: 'Kategorien',
            routerLink: 'faq/categories'
          }]
        }]
      });
    }
    static {
      this.ɵfac = /*@__PURE__*/(() => {
        let ɵFaqFrontendAdminFeature_BaseFactory;
        return function FaqFrontendAdminFeature_Factory(__ngFactoryType__) {
          return (ɵFaqFrontendAdminFeature_BaseFactory || (ɵFaqFrontendAdminFeature_BaseFactory = i0.ɵɵgetInheritedFactory(FaqFrontendAdminFeature)))(__ngFactoryType__ || FaqFrontendAdminFeature);
        };
      })();
    }
    static {
      this.ɵmod = /*@__PURE__*/i0.ɵɵdefineNgModule({
        type: FaqFrontendAdminFeature
      });
    }
    static {
      this.ɵinj = /*@__PURE__*/i0.ɵɵdefineInjector({
        providers: [provideRootRoutes([{
          path: 'faq',
          loadChildren: () => import('./faq-admin.module').then(m => m.FaqFrontendAdminModule)
        }])]
      });
    }
  };
  FaqFrontendAdminFeature = __decorate([ClassName("FaqFrontendAdminFeature")], FaqFrontendAdminFeature);
  return FaqFrontendAdminFeature;
})();
export { FaqFrontendAdminFeature };